import {Discipline} from '../api/Discipline';

export class ExDiscipline extends Discipline {
    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }

        if (this.children.length) {
            this.children.forEach((item, index) => {
                this.children[index] = new ExDiscipline(item);
            });
        }
    }

    getLabel(langue: string) {
        let str = '';
        this.translations.forEach(item => {
            if (item.locale === langue) {str = item.label;}
        });
        return str;
    }

    getId(langue: string) {
        return this['id'];
    }
}
